/**
 * OAuth Applications API queries — read operations against
 * /api/oauth_applications.
 */

import { apiClient } from '../client';

import type {
  OauthApplicationShowResponse,
  OauthApplicationsListResponse,
} from './types';

export const oauthApplicationsQueryKeys = {
  all: ['oauthApplications'] as const,
  lists: () => [...oauthApplicationsQueryKeys.all, 'list'] as const,
  list: () => [...oauthApplicationsQueryKeys.lists()] as const,
  details: () => [...oauthApplicationsQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...oauthApplicationsQueryKeys.details(), id] as const,
};

// Owner's apps — self-service cap (OAUTH_MAX_APPS_PER_OWNER, default 10)
// makes pagination pointless, so the endpoint returns the full list.
export async function getOauthApplications(): Promise<OauthApplicationsListResponse> {
  const { data } = await apiClient.get<OauthApplicationsListResponse>('/api/oauth_applications');
  return data;
}

// Detail payload bundles the app, its scope requests, and its audit trail —
// one fetch feeds all three details-page sections.
export async function getOauthApplication(id: number): Promise<OauthApplicationShowResponse> {
  const { data } = await apiClient.get<OauthApplicationShowResponse>(`/api/oauth_applications/${id}`);
  return data;
}
